<template>
    <div>
        <div>
            <el-form :model="$parentInfo.dialog_ChangeStudentPhone"
                     label-width="90px">
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="原账号">
                            <el-input v-model="$parentInfo.dialog_ChangeStudentPhone.phone"
                                      placeholder="请输入账号" disabled style="width: 200px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="24">
                        <el-form-item label="新账号">
                            <el-input v-model="$parentInfo.dialog_ChangeStudentPhone.new_phone"
                                      placeholder="请输入新账号"  style="width: 200px"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class=" text-right">
            <el-button type="primary" @click="handleUpdateStudentAccount"
                       :loading="$parentInfo.dialog_ChangeStudentPhone.button_loading">发送短信
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Dialog_ChangeStudentPhone",
        data() {
            return {
                activeTab: 1,
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.handleGetStudentAccount('');
        },
        computed: {
            powers() {
                return this.$store.state.config.powers;
            },
        },
        beforeDestroy(){
            this.$parentInfo.dialog_ChangeStudentPhone.new_phone=''
        },
        methods: {
            handleGetStudentAccount() {
                this.$wApi.send(this.$parentInfo.path, 'get_studentAccount', {
                    'student_id':this.$parentInfo.student.id,
                });
            },
            handleUpdateStudentAccount(){
                this.$confirm('确认绑定?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$parentInfo.dialog_ChangeStudentPhone.button_loading = true;
                    this.$wApi.send(this.$parentInfo.path, 'update_studentAccount', {
                        'student_id':this.$parentInfo.student.id,
                        'new_phone':this.$parentInfo.dialog_ChangeStudentPhone.new_phone,
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            }
        }
    }
</script>

<style scoped>

</style>